/*
 * Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { find } from "lodash";
import { isArray, objectHasProperty } from "utils/empty-exists";
import { Logger } from "cms/utils/log/logger";
import { fieldTypes } from "data/resources/field-config";

export function getDefaultSchemaFieldImpl (schemaSettings, type) {

    const fieldConfig = find(fieldTypes, { type });
    const defaultValue = schemaSettings?.defaultValue ?? null;
    const defaultStyle = schemaSettings?.defaultStyle ?? null;
    const defaultFormat = schemaSettings?.defaultFormat ?? null;
    // const noOverride = schemaSettings?.noOverride ?? false;
    let defaultImpl = fieldConfig?.defaultImpl;
    defaultImpl = { ...defaultImpl };

    if (objectHasProperty(defaultImpl, "settings")) {
        defaultImpl.value = defaultValue ? defaultValue : "";
        defaultImpl.settings.style = defaultStyle ? defaultStyle : defaultImpl?.settings.style;
        defaultImpl.settings.format = defaultFormat ? defaultFormat : defaultImpl?.settings.format;
    }
    // Add an options object to the defaultImpl, if missing
    if (!objectHasProperty(defaultImpl?.settings, "options")) {
        defaultImpl.settings.options = {};
    }
    // For Documents: when options.target[] -> set options.openIn
    if (objectHasProperty(schemaSettings?.options, "targets") && isArray(schemaSettings?.options?.targets)) {
        try {
            defaultImpl.settings.options.openIn = schemaSettings?.options?.targets[0].value;
        } catch (err) {
            Logger.error(`failed to set default for target/openIn ${err.message}`);
        }
    }
    // Logger.debug(`[getDefaultImpl] ${type}`, { defaultImpl });
    return defaultImpl;
}
